var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedo18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.121 11.289a1 1 0 1 1-1.414-1.415l1.879-1.879H6.057l-.052.002h-3v5h3a1 1 0 1 1 0 2h-3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2.002h9.582L10.68 4.112c-.39-.39-.363-1.019.027-1.41a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-3.586 3.587z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0xMi4xMjEgMTEuMjg5YTEgMSAwIDEgMS0xLjQxNC0xLjQxNWwxLjg3OS0xLjg3OUg2LjA1N2wtLjA1Mi4wMDJoLTN2NWgzYTEgMSAwIDEgMSAwIDJoLTNhMiAyIDAgMCAxLTItMnYtNWEyIDIgMCAwIDEgMi0yLjAwMmg5LjU4MkwxMC42OCA0LjExMmMtLjM5LS4zOS0uMzYzLTEuMDE5LjAyNy0xLjQxYTEgMSAwIDAgMSAxLjQxNCAwbDMuNTg2IDMuNTg2YTEgMSAwIDAgMSAwIDEuNDE0bC0zLjU4NiAzLjU4N3oiLz48L3N2Zz4=";
export { SvgRedo18 as ReactComponent };